'use client';

import classNames from 'classnames';

import { AnimatedText } from '@/blocks/animations/animated-text';
import { CenterHeading, VStack } from '@/blocks/components/layout';
import { WithClassName } from '@/blocks/components/types';
import { FaqBlock } from '@/blocks/sections/Questions/components/FaqBlock';
import styles from '@/blocks/sections/Questions/styles.module.scss';
import { useFaqController } from '@/providers/FAQProvider';
import typography from '@/styles/typography.module.scss';

type Props = {
  faqData: {
    question: React.ReactNode;
    answer: React.ReactNode;
  }[];
  title: React.ReactNode;
} & WithClassName;

export function FaqBlockWithHeader(props: Props) {
  const { faqController } = useFaqController();

  return (
    <div className={classNames(styles.sizeBlock, props.className)} ref={faqController.faqBlockRef}>
      <VStack>
        <CenterHeading>
          <AnimatedText className={classNames(typography.h2)}>{props.title}</AnimatedText>
        </CenterHeading>
        <FaqBlock questionsData={props.faqData} />
      </VStack>
    </div>
  );
}
